import { render, staticRenderFns } from "./ReportsRevenue.vue?vue&type=template&id=0bc22a02&"
import script from "./ReportsRevenue.vue?vue&type=script&lang=js&"
export * from "./ReportsRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports